import { useState } from 'react'
import { usersService } from '../services/usersService'
import './PasswordResetScreen.css'

interface PasswordResetScreenProps {
  onBackToLogin: () => void
}

export default function PasswordResetScreen({ onBackToLogin }: PasswordResetScreenProps) {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')

  const handleReset = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setSuccess('')
    setLoading(true)

    try {
      /* Winnie, 18 Sep: recovery is its own email, not the one that welcomes a new user onto
         the platform. usersService sends the recovery template and falls back to Supabase's
         own if this environment cannot. */
      const res = await usersService.sendPasswordRecoveryEmail(email)
      if (!res.success) throw new Error(res.message)

      /* Deliberately says nothing about whether the address is known. An answer that
         distinguishes the two is an answer that tells a stranger who has an account here. */
      setSuccess('If that address has an account, an email is on its way. Check your inbox.')
      setEmail('')

      setTimeout(() => {
        onBackToLogin()
      }, 3000)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Reset request failed')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-container">
      <div className="auth-box">
        <div className="auth-header">
          <h1>DirectAuto</h1>
          <p>Reset your password</p>
        </div>

        <form onSubmit={handleReset}>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
            />
            <div className="reset-hint">
              We'll send you a link to reset your password
            </div>
          </div>

          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}

          <button type="submit" disabled={loading} className="auth-button">
            {loading ? 'Sending link...' : 'Send Reset Link'}
          </button>
        </form>

        <div className="auth-footer">
          <button type="button" className="link-button" onClick={onBackToLogin}>
            Back to Sign In
          </button>
        </div>
      </div>
    </div>
  )
}
